import { Box, Grid, Paper, useTheme } from "@mui/material";
import { gridClasses, GridColDef } from "@mui/x-data-grid";
import { FC, useMemo } from "react";
import { Link, Outlet } from "react-router-dom";
import { Permissions, UserProject } from "../../api/dtos";
import GridActions from "../../components/GridActions";
import SetLinks from "../../components/layout/SetLinks";
import { StyledButton } from "../../components/StyledButton";
import CollapsibleTablePremium from "../../components/tables/CollapsibleTablePremium";
import { createCustomToolbarProps } from "../../components/utility/CustomToolbarProps";
import { DefaultProjectCreateLink } from "../../contexts/layouts/LinkContext";
import UserProjectsContext from "../../contexts/UserProjectsContext";
import useUserProjectSummaries from "../../hooks/data/useUserProjectSummaries";


// @Todo: Figure out how the "all" option for project permissions should be achieved, and also what it actually does
const useUserProjectColumns = () => {

    const agentColumns = useMemo(() => {
        const columns: GridColDef<UserProject>[] =  [
            {
                field: "personnel",
                headerName: "Personnel",
                flex: 1
            },
            {
                field: "location",
                headerName: "Location",
                flex: 1
            },
            {
                field: "actions",
                headerName: '',
                renderCell: (params) => {
                    return (
                        <GridActions
                            editPermission={Permissions.AdminAccess}
                            editUrl={`/admin/project-permissions/edit/${params.row.id}`}
                        />
                    )
                },
                disableExport: true
            }
        ];

        return columns;
    }, []);

    return agentColumns;
}


const ProjectPermissions:FC = () => {

    const columns = useUserProjectColumns();

    const theme = useTheme();
    
    const context = useUserProjectSummaries();

    const {data: userprojects, loading: userprojectsLoading} = context;

    const customToolbarProps = useMemo(() => createCustomToolbarProps({
        fileName: `Project Permissions`,
        exportTitle: `Project Permissions`,
        includeDateTime: true
    }), []);
    
    return (
        <UserProjectsContext.Provider value={context}>
            <Outlet />
            <SetLinks
                createProjectLink={DefaultProjectCreateLink}
                stageLinkEnabled={false}
                lotLinkEnabled={false}
            />
            <Grid
                container
                gap={theme.spacing(2)}
                justifyContent={"end"}
                marginBottom={theme.spacing(2)}
            >
                <StyledButton 
                        variant="contained"
                        //@ts-expect-error
                        component={Link}
                        to={`/admin/project-permissions/create`}
                        state={{
                            back: true
                        }}
                >
                    Add Project Permission
                </StyledButton>
            </Grid>
            <Paper>
                <Box
                    sx={{
                        [`& .${gridClasses.root}`]: {
                            
                            [`& .${gridClasses.columnHeader}`]: {
                                height: 'auto !important',
                                minHeight: 56,
                                
                                [`& .${gridClasses.columnHeaderTitleContainer}`]: {
                                    whiteSpace: 'normal',
                                    
                                    [`& .${gridClasses.columnHeaderTitle}`]: {
                                        whiteSpace: 'normal',
                                        paddingTop: theme.spacing(1.5),
                                        paddingBottom: theme.spacing(1.5) 
                                    }
                                },
                                
                                [`& .${gridClasses.iconButtonContainer}`]: {
                                    width: 'unset',
                                },
                                
                                '&.column-group-header': {
                                    backgroundColor: theme.palette.grey[300],
                                    boxShadow: "1",
                                    textAlign: 'center'
                                }
                            }
                        },
                    }}
                    >
                    <CollapsibleTablePremium
                        density="compact"
                        startCollapsed={false} 
                        title={"Project Permissions"} 
                        loading={userprojectsLoading} 
                        columns={columns}
                        rows={userprojects}
                        disableColumnMenu={false}
                        disableColumnFilter={false}
                        {...customToolbarProps}
                    />
                </Box>
            </Paper>
        </UserProjectsContext.Provider>
    );
}

export default ProjectPermissions;